// The crew's pages: My day, My schedule, a visit, time off, My pay, and View as.
import { createRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { CrewVisit } from "../../screens/CrewVisit";
import { MyPay } from "../../screens/MyPay";
import { MyTimeOff } from "../../screens/MyTimeOff";
import { ViewAs } from "../../screens/ViewAs";
import { Allowed, app, CrewOnly, page } from "./base";

const crewVisit = createRoute({
  getParentRoute: () => app,
  path: "/my-day/$ref",
  component: function CrewVisitRoute(): ReactNode {
    const { ref } = crewVisit.useParams();
    return (
      <Allowed action="myvisit.update">
        <CrewVisit key={ref} visitRef={ref} />
      </Allowed>
    );
  },
});

/** View as, one visit: the visit as that crew member sees it, read only (owner, 2026-11-02). */
const viewAsVisit = createRoute({
  getParentRoute: () => app,
  path: "/hr/team/$personId/visit/$ref",
  component: function ViewAsVisitRoute(): ReactNode {
    const { personId, ref } = viewAsVisit.useParams();
    return (
      <Allowed action="security.read">
        <CrewVisit key={`${personId}:${ref}`} visitRef={ref} viewAs={personId} />
      </Allowed>
    );
  },
});

const viewAs = createRoute({
  getParentRoute: () => app,
  path: "/hr/team/$personId/day",
  component: function ViewAsRoute(): ReactNode {
    const { personId } = viewAs.useParams();
    return (
      <Allowed action="security.read">
        <ViewAs key={personId} personId={personId} />
      </Allowed>
    );
  },
});

export const crewRoutes = [
  viewAs,
  viewAsVisit,
  page("/my-day", () => <CrewOnly />),
  page("/my-schedule", () => <CrewOnly page="schedule" />),
  page("/my-time-off", () => (
    <Allowed action="myday.read">
      <MyTimeOff />
    </Allowed>
  )),
  crewVisit,
  page("/my-pay", () => (
    <Allowed action="mypay.read">
      <MyPay />
    </Allowed>
  )),
] as const;
